import Page, {
  PageMain,
  PageSidebar,
  PageTitle,
} from '../../components/ui/page';
import Feed from '../../components/feed';
import { useHomepageFeedQuery } from '../../common/queries/use-homepagefeed-query';
import {
  ContentHomepageModule,
  HomepageModulesResponse,
} from '../../models/home-page-custom/types';
import { useRouteMatch } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import MojoApiFactory from '../../config/api-factory';
import NotFound from '../not-found';
import { FilteredFeedNav } from '../../components/filtered-feed-nav/filtered-feed-nav';

export const HomepageModuleFeed = () => {
  const {
    params: { homepageId, moduleId },
  } = useRouteMatch<{ homepageId: string; moduleId: string }>();

  const { data: contentHomepageModule, isError: moduleLoadIsError } = useQuery({
    queryKey: ['homepageModule', homepageId, moduleId],
    queryFn: async () => {
      const data = (
        (await MojoApiFactory.optimus.get(
          `web_homepage/${homepageId}/modules/${moduleId}`
        )) as AxiosResponse<HomepageModulesResponse>
      )?.data;
      if (
        !data ||
        data.attributes.id.toString() !== moduleId ||
        data.attributes.type !== 'content'
      ) {
        throw new Error('Module not found');
      }
      return data.attributes as ContentHomepageModule;
    },
  });

  const {
    rawQueryData,
    data: feedItems = [],
    isFetching,
    isFetchingNextPage,
    hasNextPage: canLoadMore,
    fetchNextPage: fetchFeed,
  } = useHomepageFeedQuery({
    contentModule: contentHomepageModule,
  });

  const fetching = isFetching || isFetchingNextPage;

  const pageTitle = contentHomepageModule?.attributes.name;

  const analyticsData = {
    module_id: contentHomepageModule?.id,
    location: 'homepage_module_feed',
  };

  if (moduleLoadIsError) {
    return <NotFound />;
  }

  return (
    <Page>
      <PageSidebar>
        <PageTitle>{pageTitle}</PageTitle>
        <FilteredFeedNav />
      </PageSidebar>

      <PageMain>
        <Feed
          items={feedItems}
          page={rawQueryData?.pages.length || 0}
          fetching={fetching}
          canLoadMore={canLoadMore || false}
          fetchFeed={fetchFeed}
          analyticsData={analyticsData}
          titleHeadingLevel={2}
        />
      </PageMain>
    </Page>
  );
};
